import { useState } from "react";
import { FormikContextType, FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import { useNewsletterRegistrationsCreateMutation } from "~/store/api";

interface NewsletterValue {
  email: string;
}

export type NewsletterFormik = FormikContextType<NewsletterValue>;

const initialValues: NewsletterValue = {
  email: "",
};

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Required"),
});

interface NewsletterFormFunctionProps {
  hasSubmitted: boolean;
  formik: NewsletterFormik;
}

export const useNewsletterForm = (): NewsletterFormFunctionProps => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [apiNewsletterRegistrationsCreate] =
    useNewsletterRegistrationsCreateMutation();

  const handleSubmit = async (
    values: NewsletterValue,
    { setSubmitting }: FormikHelpers<NewsletterValue>,
  ) => {
    setSubmitting(true);
    await apiNewsletterRegistrationsCreate(values);
    setHasSubmitted(true);
    setSubmitting(false);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    validationSchema,
  });

  return { hasSubmitted, formik };
};
